module.exports = __webpack_public_path__ + "static/media/eth.5793f215.png";